var map = {
	"./Shopinsafe/nextrel/Logo.svg": "6ebc",
	"./Shopinsafe/rel/Logo.svg": "edd1",
	"./Sic/nextrel/Logo.svg": "7ef2",
	"./Sic/rel/Logo.svg": "fe04"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "db3b";